import ValidationRule from '../validation.rule.js';
import PasswordItemRule from './password-item.rule';

export default class ExpectLowercaseRule extends PasswordItemRule {
    // https://theprogrammingexpert.com/check-if-string-contains-uppercase-javascript/
    checkLowercase(str){
        for (var i=0; i<str.length; i++){
            if (str.charAt(i) == str.charAt(i).toLowerCase() && str.charAt(i).match(/[a-z]/i)){
                return true;
            }
        }
        return false;
    };

    isValid() {
        return this.checkLowercase(this.password.element.value);
    }

    getRuleName() {
        return 'expect-lowercase';
    }
}
